import styled from 'styled-components';

// export const Output = styled.div`
//   display: flex;
//   padding-top: 20px;
//   padding-bottom: 30px;
//   height: 60px;
//   justify-content: center;
//   align-items: center;
//   color: ${({ theme }) => theme.text};
//   text-transform: uppercase;
//   font-size: 36px;
//   letter-spacing: 0.1rem;
//   font-weight: 700;
// `

export const WordlineWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
